import gsap from 'gsap';

export default () => {
	const duration = 1;
	const ease = 'power3.out';

	let offset = {};
	offset.val = window.scrollY;

	let durationMultiplier = Math.abs(offset.val) / 1500;

	gsap.to(offset, {
		val: 0,
		duration: duration * durationMultiplier,
		ease: ease,
		onUpdate: () => {
			window.scrollTo(0, offset.val);
		}
	});
}